var chunkMapping = {
	"47": [
		8047
	],
	"361": [
		361
	],
	"501": [
		5501
	],
	"557": [
		557
	],
	"797": [
		5797
	],
	"817": [
		4817
	]
};
var idToExternalAndNameMapping = {
	"361": [
		"default",
		"./Reservations",
		568
	],
	"557": [
		"default",
		"./Properties",
		4150
	],
	"4817": [
		"default",
		"./Home",
		11
	],
	"5501": [
		"default",
		"./Favorites",
		1083
	],
	"5797": [
		"default",
		"./Trips",
		2090
	],
	"8047": [
		"default",
		"./Categories",
		2997
	]
};
var idToRemoteMap = {
	"361": [
		{
			"externalType": "script",
			"name": "airbnb_reservations"
		}
	],
	"557": [
		{
			"externalType": "script",
			"name": "airbnb_properties"
		}
	],
	"4817": [
		{
			"externalType": "script",
			"name": "airbnb_home"
		}
	],
	"5501": [
		{
			"externalType": "script",
			"name": "airbnb_favorites"
		}
	],
	"5797": [
		{
			"externalType": "script",
			"name": "airbnb_trips"
		}
	],
	"8047": [
		{
			"externalType": "script",
			"name": "airbnb_categories"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"361": {
		"shareScope": "default",
		"name": "./Reservations",
		"externalModuleId": 568,
		"remoteName": "airbnb_reservations"
	},
	"557": {
		"shareScope": "default",
		"name": "./Properties",
		"externalModuleId": 4150,
		"remoteName": "airbnb_properties"
	},
	"4817": {
		"shareScope": "default",
		"name": "./Home",
		"externalModuleId": 11,
		"remoteName": "airbnb_home"
	},
	"5501": {
		"shareScope": "default",
		"name": "./Favorites",
		"externalModuleId": 1083,
		"remoteName": "airbnb_favorites"
	},
	"5797": {
		"shareScope": "default",
		"name": "./Trips",
		"externalModuleId": 2090,
		"remoteName": "airbnb_trips"
	},
	"8047": {
		"shareScope": "default",
		"name": "./Categories",
		"externalModuleId": 2997,
		"remoteName": "airbnb_categories"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}